import { Guid } from '@web/utils';

export class AdminBrandDetailsFormSocialMedia {
  public constructor(
    public readonly id: Guid,
    public readonly url: string,
  ) {}
}
